module.exports = __webpack_public_path__ + "static/media/bg1.24748b68.webp";